import React from 'react'
import { useBranding } from '../../context/BrandingContext';

import "./GreInstructionsModal.css";

const GreInstructionsModal = ({ open = false, onClose, onContinue }) => {
    const { colors } = useBranding();
    if (!open) return null;
    return (
        <div>
            <div className="gre-modal__backdrop" role="dialog" aria-modal="true" aria-labelledby="gre-modal-title">
                <div className="gre-modal">
                    {/* Top Toolbar */}
                    <div className='gre-header' style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 24px" }}>
                        <div className="gre-toolbar ">
                            <div>GRE</div>
                            <div> - Practice Test</div>
                        </div>
                        <div onClick={onClose} style={{ cursor: "pointer" }}>
                            <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect width="24" height="24" fill="none"></rect> <path d="M7 17L16.8995 7.10051" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M7 7.00001L16.8995 16.8995" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                        </div>
                    </div>


                    <div className="">
                        <div style={{ padding: "12px 24px 0" }}>Section 5 of 5</div>
                    </div>

                    {/* Content */}
                    <div className="gre-content">
                        <h2 id="gre-modal-title" className="gre-title">Quantitative Reasoning</h2>
                        <div className="gre-subtitle">15 Questions<br />26 minutes (standard time)</div>

                        <p>
                            For each question, indicate the best answer, using the directions given. If you need more detailed
                            directions, select <strong>Help</strong> at any time.
                        </p>

                        <p>
                            <strong>An on-screen calculator is available for each question in this section. To use the calculator, select the calculator button.</strong>
                        </p>

                        <p>
                            If a question has answer choices with <strong>ovals</strong> <span className="oval" /> then the correct answer consists of a single choice. If a question has answer
                            choices with <strong>square boxes</strong> <span className="square" /> then the correct answer consists of one or more answer choices. Read the directions for each
                            question carefully. The directions will indicate if you should select one or more answer choices. To answer questions based on a
                            data presentation, you may need to scroll or use your keyboard to access the entire presentation.
                        </p>

                        <ul className="gre-bullets">
                            <li>All numbers used are real numbers.</li>
                            <li>All figures are assumed to lie in a plane unless otherwise indicated.</li>
                            <li>
                                Geometric figures, such as lines, circles, triangles, and quadrilaterals, are <strong>not necessarily</strong> drawn to scale. That is, you should not
                                assume that quantities such as lengths and angle measures are as they appear in a figure. You should assume, however, that lines shown as straight are actually straight, points on a line are in the order shown, and more generally, all geometric objects are in the relative positions shown. For questions with geometric figures, you should base your answers on geometric reasoning, not on estimating or comparing quantities by sight or by measurement.
                            </li>
                            <li>
                                Coordinate systems, such as <i>xy</i>-planes and number lines, <strong>are</strong> drawn to scale; therefore you can read, estimate, or compare quantities in such figures by sight or by measurement.
                            </li>
                            <li>
                                Graphical data presentations, such as bar graphs, circle graphs, and line graphs, <strong>are</strong> drawn to scale; therefore, you can read, estimate, or compare data values by sight or by measurement.
                            </li>
                        </ul>

                        <p className="gre-bottom">Select <strong>Continue</strong> to proceed.</p>
                    </div>

                    {/* Footer actions (sticky on small screens) */}
                    <div className="gre-footer">
                        {/* <button className="btn ghost" onClick={onClose}>Close</button> */}
                        <div className="flex-spacer" />
                        <button className="btn black" onClick={onContinue} style={{ backgroundColor: colors?.buttonBg }}>Continue</button>
                    </div>
                </div>


            </div>
        </div>
    )
}

export default GreInstructionsModal